import React from 'react'
import classNames from 'classnames'
import { BackLinkProps, BackLink } from '~/code/components/BackLink'
import styles from './EcospendBackLink.scss'

export const EcospendBackLink: React.FC<BackLinkProps> = ({ className, ...rest }) => (
    <BackLink className={classNames(styles.EcospendBackLink, className)} {...rest} />
)
